import React from 'react'

const Footer = () => {
  return (
    <div style={{ width: '100%', height: '32px'}}></div>
  )
}

export default Footer
